import React from 'react';
import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { Box } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ComponentInfo, DisplayGroupRender } from '@components';
import { rem } from '@helpers';
import { LEFT_PANEL_WIDTH } from '@constants';
import { useValuesByScreenSize } from '@hooks';
import { ROUTES } from '@navigation';

export const BodyPanel: React.FC<DisplayGroupProps> = (props: DisplayGroupProps) => {
	const valuesByScreenSize = useValuesByScreenSize(rem(56, 106, 222, 106), rem(56, 48, 222, 48));
	const padding = window.location.pathname !== ROUTES.intro ? valuesByScreenSize : 'unset';

	return (
		<ComponentInfo name="BodyPanel">
			<Box
				styles={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center', //this can be a problem validate if the screens with more component if dont break
					flexGrow: 1,
					padding,
					width: `calc(100vw - ${rem(LEFT_PANEL_WIDTH)})`,
				}}
			>
				<DisplayGroupRender displayGroupsProps={props} />
			</Box>
		</ComponentInfo>
	);
};
